import { theme } from '@/theme';
import { CARD_DIMENSION_IN_PIXELS } from '@/views/Home/components/NeedsAttention/components/NeedsAttentionCard';

export const CARD_SPACING = 20;
export const TOTAL_CARD_WIDTH = CARD_DIMENSION_IN_PIXELS + CARD_SPACING;

const roundToTwoDecimalPlaces = (num: number) =>
  Math.round((num + Number.EPSILON) * 100) / 100;

/**
 * Get the number of cards that can fit in a container based on the container width,
 * the width of the cards, and the space between the cards
 * @param container The container to calculate the number of cards that can fit
 * @returns The number of cards that fit in the container, or undefined if the container is null
 */
export function getCardsPerPage(container: HTMLDivElement | null) {
  if (!container) return undefined;
  const width = container.clientWidth;
  const isMobile = theme.breakpoints.values.md >= window.innerWidth;
  const result = (width + CARD_SPACING) / TOTAL_CARD_WIDTH;

  return isMobile ? roundToTwoDecimalPlaces(result) : Math.floor(result);
}
